export interface SectionProgressStateLike {
  start_date?: string | null;
  completion_date?: string | null;
  time_accumulator?: number | null;
  score?: number | null;
  progress?: { steps?: unknown[] } | null;
}

export function hasSectionStarted(
  section: SectionProgressStateLike | null | undefined,
): boolean {
  const hasProgressSteps = Array.isArray(section?.progress?.steps)
    ? section.progress.steps.length > 0
    : false;

  return Boolean(
    section?.start_date ||
    section?.completion_date ||
    (section?.time_accumulator || 0) > 0 ||
    (section?.score || 0) > 0 ||
    hasProgressSteps,
  );
}

export interface SectionStepFinishedLike {
  completion_date?: string | null;
  isSkippedFilter?: boolean | null;
}

/**
 * A step needs no more work when it was completed or skipped. `nextSectionStep`
 * already walks past both, so anything that asks "is this section done" has to
 * count them the same way — otherwise a section ending in skipped correction
 * steps never reads as finished.
 */
export function isSectionStepFinished(
  step: SectionStepFinishedLike | null | undefined,
): boolean {
  return Boolean(step?.completion_date || step?.isSkippedFilter);
}

export function countFinishedSectionSteps(
  steps?: SectionStepFinishedLike[] | null,
): number {
  if (!Array.isArray(steps)) return 0;
  return steps.filter(isSectionStepFinished).length;
}
